import React, { useEffect, useState } from "react";

export function useOnScreen(
  ref: React.RefObject<any>,
  options?: { rootMargin?: string; root?: HTMLElement } | undefined,
  deps?: Array<any>,
): boolean {
  const { rootMargin = "0px", root } = options || {};

  // State and setter for storing whether element is visible
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    // In reality we expect our users to be using a modern browser,
    // but we also use useOnScreen in our tests, where IntersectionObserver
    // is not available.
    if (typeof IntersectionObserver === "undefined") {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      },
      { rootMargin, root },
    );

    const currentRef = ref.current;

    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [root, ...(deps || [])]);

  return isIntersecting;
}
